
import { Component, Vue, Prop, Watch} from 'vue-property-decorator';

import LoansCreditsFsSurvey from "./LoansCreditsFSSurvey.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";

import PageBase from "../../PageBase.vue";

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

@Component({
    components:{
      LoansCreditsFsSurvey,
      PageBase
    }
})
export default class LoansCreditsFS extends Vue {
  
    @Prop({required: true})
    step!: stepInfoType

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void
    

    @Watch('loansCreditsData')
    loansCreditsDataChange(newVal) 
    {
        this.UpdateStepResultData({step:this.step, data: {loansCreditsFSSurvey: this.getLoansCreditsResults()}})  
    }

    currentStep =0;
    currentPage =0;
    showTable = true;
    loansCreditsData = [];
    anyRowToBeEdited = null;
    editId = null;
 
    created() {
        if (this.step.result?.loansCreditsFSSurvey?.data) {
            this.loansCreditsData = this.step.result.loansCreditsFSSurvey.data;
        }
    }

    mounted(){        
        const progress = this.loansCreditsData?.length>0? 100 : 50;            
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
        Vue.nextTick(()=>{
            const el = document.getElementById('loans-credits-fs-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public childComponentData(value) {
        this.showTable = value;
    }

    public populateSurveyData(loansCreditsValue) {
        const currentIndexValue = this.loansCreditsData?.length > 0 ? this.loansCreditsData[this.loansCreditsData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newLoansCredits = { ...loansCreditsValue, id };

        this.loansCreditsData = this.loansCreditsData? [...this.loansCreditsData, newLoansCredits]:[newLoansCredits];

        this.showTable = true; 
    }

    public deleteRow(rowToBeDeleted) {
        this.loansCreditsData = this.loansCreditsData.filter(data => {
            return data.id !== rowToBeDeleted;
        });
    }

    public editRow(editedRow) {
        this.loansCreditsData = this.loansCreditsData.map(data => {
            return data.id == this.editId ? editedRow : data;
        });
        this.showTable = true;
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();
    }

    public isDisableNext() {    
        if(this.loansCreditsData?.length > 0) return false;
        else return true;
    }    

    beforeDestroy() {
        const progress = this.loansCreditsData?.length>0? 100 : 50;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);
        this.UpdateStepResultData({step:this.step, data:{loansCreditsFSSurvey: this.getLoansCreditsResults()}})       
    }
   
    public getLoansCreditsResults(){
        const questionResults: {name:string; value: string[]; title:string; inputType:string}[] =[];
        if(this.loansCreditsData)
            for(const loansCredits of this.loansCreditsData)
            {
                questionResults.push({name:'loansCreditsFSSurvey', value: this.getLoansCreditsInfo(loansCredits), title:'Loans and credits '+loansCredits.id +' Information', inputType:''})
            }

        return {data: this.loansCreditsData, questions:questionResults, pageName:'Loans and credits', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getLoansCreditsInfo(loansCredits){        
        const resultString: string[] = [];
        resultString.push(Vue.filter('styleTitle')("Description: ")+loansCredits.loansCreditsDescription);
        resultString.push(Vue.filter('styleTitle')("Value: ")+loansCredits.loansCreditsValue);
        return resultString
    }

}
